(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
document.addEventListener('change', event => {
  if (event.target.matches('[data-language-selector]')) event.target.form.submit();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hero-product-map')) {
  customElements.define('hero-product-map', class extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('img');
      if (!this.image) return;
      this.abort = new AbortController();
      this.resizeObserver = new ResizeObserver(() => this.positionLinks());
      this.resizeObserver.observe(this);
      this.image.addEventListener('load', () => this.positionLinks(), { signal: this.abort.signal });
      this.positionLinks();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resizeObserver?.disconnect();
    }
    positionLinks() {
      const image = this.image;
      if (!image?.naturalWidth || !image.naturalHeight) return;
      const width = this.clientWidth;
      const height = this.clientHeight;
      const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight);
      const renderedWidth = image.naturalWidth * scale;
      const renderedHeight = image.naturalHeight * scale;
      const offsetX = (width - renderedWidth) / 2;
      const offsetY = (height - renderedHeight) / 2;
      for (const link of this.querySelectorAll('.hero-hotspot')) {
        const x = offsetX + Number(link.dataset.x) * renderedWidth;
        const y = offsetY + Number(link.dataset.y) * renderedHeight;
        link.style.left = `${x}px`;
        link.style.top = `${y}px`;
        link.style.width = `${Math.max(44, Number(link.dataset.width) * renderedWidth)}px`;
        link.style.height = `${Math.max(44, Number(link.dataset.height) * renderedHeight)}px`;
        const visible = x >= 0 && x <= width && y >= 0 && y <= height;
        link.hidden = !visible;
        link.style.display = visible ? '' : 'none';
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  const mediaZoomStates = new WeakMap();

  function clampZoomValue(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
  }

  function mediaBaseScale() { return 1; }

  function zoomState(media) {
    if (!mediaZoomStates.has(media)) {
      mediaZoomStates.set(media, {
        pointers: new Map(),
        zoom: 1,
        x: 0,
        y: 0,
        startZoom: 1,
        startX: 0,
        startY: 0,
        startDistance: 0,
        startMidpoint: null,
        contentPoint: null,
        dragStart: null,
        startStageScroll: 0,
        moved: false,
        pinched: false
      });
    }
    return mediaZoomStates.get(media);
  }

  function pointerMidpoint(pointers) {
    const values = [...pointers.values()];
    return {
      x: (values[0].x + values[1].x) / 2,
      y: (values[0].y + values[1].y) / 2
    };
  }

  function pointerDistance(pointers) {
    const values = [...pointers.values()];
    return Math.hypot(values[1].x - values[0].x, values[1].y - values[0].y);
  }

  function applyMediaZoom(media, zoom, x, y) {
    const state = zoomState(media);
    const image = media.querySelector('.product-media__image');
    if (!image) return;
    const rect = media.getBoundingClientRect();
    state.zoom = clampZoomValue(zoom, 1, 4);
    const effectiveScale = mediaBaseScale(media) * state.zoom;
    const imageWidth = image.naturalWidth || image.width || rect.width;
    const imageHeight = image.naturalHeight || image.height || rect.height;
    const fittedScale = Math.min(rect.width / imageWidth, rect.height / imageHeight);
    const maxX = Math.max(0, (imageWidth * fittedScale * effectiveScale - rect.width) / 2);
    const maxY = Math.max(0, (imageHeight * fittedScale * effectiveScale - rect.height) / 2);
    state.x = clampZoomValue(x, -maxX, maxX);
    state.y = clampZoomValue(y, -maxY, maxY);
    const isZoomed = state.zoom > 1.01;
    image.style.transform = isZoomed
      ? 'translate3d(' + state.x + 'px, ' + state.y + 'px, 0) scale(' + (mediaBaseScale(media) * state.zoom) + ')'
      : '';
    media.dataset.zoomed = String(isZoomed);
    if (media.dataset.zoomEnabled === 'true') media.setAttribute('aria-pressed', String(isZoomed));
    media.closest('.product-media-stage').dataset.zoomed = String(isZoomed);
  }

  function resetMediaZoom(media) {
    const state = zoomState(media);
    state.zoom = 1;
    state.x = 0;
    state.y = 0;
    state.pointers.clear();
    state.pinched = false;
    const image = media.querySelector('.product-media__image');
    if (image) image.style.transform = '';
    media.dataset.zoomed = 'false';
    if (media.dataset.zoomEnabled === 'true') media.setAttribute('aria-pressed', 'false');
    media.dataset.zooming = 'false';
    const stage = media.closest('.product-media-stage');
    if (stage) stage.dataset.zoomed = 'false';
  }

  function resetProductZoom(root) {
    root.querySelectorAll('[data-product-media]').forEach(resetMediaZoom);
  }

  function zoomAtPoint(media, zoom, clientX, clientY) {
    const state = zoomState(media);
    const rect = media.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const currentScale = mediaBaseScale(media) * state.zoom;
    const nextScale = mediaBaseScale(media) * zoom;
    const contentX = (clientX - centerX - state.x) / currentScale;
    const contentY = (clientY - centerY - state.y) / currentScale;
    applyMediaZoom(
      media,
      zoom,
      clientX - centerX - contentX * nextScale,
      clientY - centerY - contentY * nextScale
    );
  }

  function enableInlineZoom(stage) {
    stage.querySelectorAll('[data-product-media]').forEach(media => {
      const image = media.querySelector('.product-media__image');
      if (!image || media.dataset.zoomEnabled === 'true') return;
      media.dataset.zoomEnabled = 'true';
      media.setAttribute('role', 'button');
      media.setAttribute('aria-label', image.alt);
      media.setAttribute('aria-pressed', 'false');
      media.tabIndex = media.dataset.active === 'true' ? 0 : -1;
      const state = zoomState(media);

      media.addEventListener('pointerdown', event => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        media.setPointerCapture?.(event.pointerId);
        state.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        state.moved = false;
        state.dragStart = { x: event.clientX, y: event.clientY, imageX: state.x, imageY: state.y };
        state.startStageScroll = stage.scrollLeft;

        if (state.pointers.size === 2) {
          event.preventDefault();
          state.pinched = true;
          state.startZoom = state.zoom;
          state.startX = state.x;
          state.startY = state.y;
          state.startDistance = pointerDistance(state.pointers);
          state.startMidpoint = pointerMidpoint(state.pointers);
          const rect = media.getBoundingClientRect();
          const currentScale = mediaBaseScale(media) * state.zoom;
          state.contentPoint = {
            x: (state.startMidpoint.x - (rect.left + rect.width / 2) - state.x) / currentScale,
            y: (state.startMidpoint.y - (rect.top + rect.height / 2) - state.y) / currentScale
          };
          media.dataset.zooming = 'true';
        }
      });

      media.addEventListener('pointermove', event => {
        if (!state.pointers.has(event.pointerId)) return;
        state.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        if (state.pointers.size >= 2) {
          event.preventDefault();
          const midpoint = pointerMidpoint(state.pointers);
          const distance = pointerDistance(state.pointers);
          const zoom = clampZoomValue(state.startZoom * distance / state.startDistance, 1, 4);
          const rect = media.getBoundingClientRect();
          const effectiveScale = mediaBaseScale(media) * zoom;
          applyMediaZoom(
            media,
            zoom,
            midpoint.x - (rect.left + rect.width / 2) - state.contentPoint.x * effectiveScale,
            midpoint.y - (rect.top + rect.height / 2) - state.contentPoint.y * effectiveScale
          );
          state.moved = true;
          return;
        }

        if (!state.dragStart) return;
        const dx = event.clientX - state.dragStart.x;
        const dy = event.clientY - state.dragStart.y;
        if (Math.hypot(dx, dy) > 6) state.moved = true;
        if (state.zoom > 1.01) {
          event.preventDefault();
          applyMediaZoom(media, state.zoom, state.dragStart.imageX + dx, state.dragStart.imageY + dy);
        } else if (Math.abs(dx) > Math.abs(dy)) {
          stage.scrollLeft = state.startStageScroll - dx;
        }
      });

      function finishPointer(event) {
        if (!state.pointers.has(event.pointerId)) return;
        if (event.type === 'pointercancel' || state.pinched) state.moved = true;
        state.pointers.delete(event.pointerId);
        media.releasePointerCapture?.(event.pointerId);

        if (state.pointers.size === 1) {
          const remaining = [...state.pointers.values()][0];
          state.dragStart = { x: remaining.x, y: remaining.y, imageX: state.x, imageY: state.y };
        }

        if (state.pointers.size === 0) {
          media.dataset.zooming = 'false';
          if (state.zoom <= 1.01) resetMediaZoom(media);
          state.pinched = false;
          state.dragStart = null;
        }
      }

      media.addEventListener('pointerup', finishPointer);
      media.addEventListener('pointercancel', finishPointer);
      media.addEventListener('click', event => {
        if (state.moved || state.pinched || event.detail > 1) return;
        event.preventDefault();
        zoomAtPoint(media, state.zoom > 1.01 ? 1 : 2.5, event.clientX, event.clientY);
      });
      media.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          resetMediaZoom(media);
        } else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          const rect = media.getBoundingClientRect();
          zoomAtPoint(media, state.zoom > 1.01 ? 1 : 2.5, rect.left + rect.width / 2, rect.top + rect.height / 2);
        }
      });
    });
  }

  const galleryBanks = new WeakMap();

  function galleryBank(root) {
    if (!galleryBanks.has(root)) {
      try {
        galleryBanks.set(root, JSON.parse(root.querySelector('[data-gallery-data]')?.textContent || '{}'));
      } catch {
        galleryBanks.set(root, {});
      }
    }
    return galleryBanks.get(root);
  }

  function updateVariantGallery(root, variant) {
    if (!root || !variant) return;
    const bank = galleryBank(root);
    const views = bank.variants?.[variant.value];
    if (!views?.length) return;
    const stage = root.querySelector('.product-media-stage');
    let thumbnails = root.querySelector('.product-thumbnails');
    const activeId = stage.querySelector('[data-active="true"]')?.dataset.mediaId;
    const activeIndex = Number(activeId?.replace('ohara-view-', '')) || 0;
    if (root.dataset.galleryReady !== 'true' && !stage.querySelector('[data-media-id="ohara-view-0"]')) {
      const output = stage.querySelector('[data-scale-value]');
      stage.replaceChildren();
      if (!thumbnails) {
        thumbnails = document.createElement('div');
        thumbnails.className = 'product-thumbnails';
        thumbnails.setAttribute('role', 'list');
        thumbnails.setAttribute('aria-label', root.querySelector('.product-title').textContent.trim());
        stage.after(thumbnails);
      }
      thumbnails.replaceChildren();
      views.forEach((view, index) => {
        const figure = document.createElement('figure');
        figure.className = 'product-media';
        figure.dataset.productMedia = '';
        figure.dataset.mediaId = `ohara-view-${index}`;
        figure.dataset.galleryKind = view.kind;
        figure.dataset.scaleTarget = 'false';
        figure.dataset.active = String(index === activeIndex);
        figure.setAttribute('aria-hidden', String(index !== activeIndex));
        const img = document.createElement('img');
        img.className = 'product-media__image';
        img.width = view.width || 1536;
        img.height = view.height || 1024;
        img.decoding = 'async';
        figure.append(img);
        stage.append(figure);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-thumbnail';
        button.dataset.galleryThumb = '';
        button.dataset.mediaId = figure.dataset.mediaId;
        button.setAttribute('aria-pressed', String(index === activeIndex));
        button.setAttribute('role', 'listitem');
        const thumb = document.createElement('img');
        thumb.className = 'product-thumbnail__image';
        thumb.width = 88;
        thumb.height = 88;
        button.append(thumb);
        thumbnails.append(button);
      });
      if (output) stage.append(output);
      root.dataset.galleryReady = 'true';
    }
    root.dataset.galleryReady = 'true';
    views.forEach((view, index) => {
      const media = stage.querySelector(`[data-media-id="ohara-view-${index}"]`);
      const label = bank.labels?.[view.label] || view.label;
      updateMediaImage(root, media, view.url, `${bank.title} — ${label} — ${variant.dataset.title}`);
      const image = media.querySelector('img');
      image.width = view.width;
      image.height = view.height;
    });
    // Preserve the selected view and camera frame on both metal and carat changes.
    // Only the variant's on-body photograph contains a differently sized jewel.
    showProductMedia(root, `ohara-view-${Math.min(activeIndex, views.length - 1)}`);
  }

  function caratValue(title) {
    const match = title.match(/(\d+(?:[.,]\d+)?)\s*ct/i);
    return match ? Number(match[1].replace(',', '.')) : null;
  }

  function updateGalleryCaption(root, media) {
    const output = root.querySelector('[data-scale-value]');
    const variant = root.querySelector('[data-product-variant]')?.selectedOptions[0];
    if (!output || !variant) return;
    const scale = galleryBank(root).scales?.[variant.value];
    output.textContent = media?.dataset.galleryKind === 'on-body' && scale ? scale : variant.dataset.title?.split('/')[0].trim() || '';
  }

  function showProductMedia(root, mediaId) {
    resetProductZoom(root);
    const items = [...root.querySelectorAll('[data-product-media]')];
    const requested = items.find(item => item.dataset.mediaId === mediaId) || items[0];
    if (!requested) return;
    updateGalleryCaption(root, requested);
    items.forEach(item => {
      const isActive = item === requested;
      item.dataset.active = String(isActive);
      item.setAttribute('aria-hidden', String(!isActive));
      if (item.querySelector('.product-media__image')) item.tabIndex = isActive ? 0 : -1;
    });
    root.querySelectorAll('[data-gallery-thumb]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.mediaId === requested.dataset.mediaId));
    });
    if (window.matchMedia('(max-width: 989px)').matches) {
      const stage = requested.closest('.product-media-stage');
      stage?.scrollTo({ left: requested.offsetLeft, behavior: 'smooth' });
    }
  }

  function syncProductGallery(stage) {
    if (stage.dataset.zoomed === 'true') return;
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    const items = [...stage.querySelectorAll('[data-product-media]')];
    if (!items.length || !stage.clientWidth) return;
    const index = Math.max(0, Math.min(items.length - 1, Math.round(stage.scrollLeft / stage.clientWidth)));
    const active = items[index];
    const root = stage.closest('[data-diamond-product]');
    updateGalleryCaption(root, active);
    items.forEach(item => {
      const isActive = item === active;
      item.dataset.active = String(isActive);
      item.setAttribute('aria-hidden', String(!isActive));
      if (item.querySelector('.product-media__image')) item.tabIndex = isActive ? 0 : -1;
    });
    root.querySelectorAll('[data-gallery-thumb]').forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.mediaId === active.dataset.mediaId));
    });
    root.querySelector(`[data-gallery-thumb][data-media-id="${active.dataset.mediaId}"]`)?.scrollIntoView({
      block: 'nearest',
      inline: 'nearest'
    });
  }

  function responsiveImageUrl(source, width) {
    const url = new URL(source, window.location.origin);
    url.searchParams.set('width', String(width));
    return url.toString();
  }

  function responsiveImageSrcset(source, widths) {
    return widths.map(width => `${responsiveImageUrl(source, width)} ${width}w`).join(', ');
  }

  function updateMediaImage(root, media, source, alt) {
    if (!media || !source) return;
    const image = media.querySelector('img');
    if (image) {
      const isPrimary = media.dataset.mediaId === 'ohara-view-0';
      image.srcset = responsiveImageSrcset(source, [600, 900, 1200, 1600, 1800]);
      image.sizes = '(min-width: 990px) 52vw, 100vw';
      image.loading = isPrimary ? 'eager' : 'lazy';
      image.fetchPriority = isPrimary ? 'high' : 'auto';
      image.src = responsiveImageUrl(source, 1800);
      image.alt = alt;
      if (media.dataset.zoomEnabled === 'true') media.setAttribute('aria-label', alt);
    }
    const thumbnail = root.querySelector(`[data-gallery-thumb][data-media-id="${media.dataset.mediaId}"] img`);
    if (thumbnail) {
      thumbnail.srcset = responsiveImageSrcset(source, [120, 180, 240]);
      thumbnail.sizes = '88px';
      thumbnail.loading = 'lazy';
      thumbnail.src = responsiveImageUrl(source, 240);
      thumbnail.alt = alt;
      thumbnail.closest('[data-gallery-thumb]').setAttribute('aria-label', alt);
    }
  }

  function updateProductScale(root, select, title) {
    const output = root.querySelector('[data-scale-value]');
    if (output) output.textContent = title.split('/')[0].trim();
  }

  function updateProductContactLink(root, variant) {
    const link = root.querySelector('[data-product-contact]');
    if (!link || !variant) return;
    const contactUrl = new URL(link.href, window.location.origin);
    const productUrl = new URL(window.location.href);
    productUrl.search = '';
    productUrl.searchParams.set('variant', variant.value);
    contactUrl.searchParams.set('product', link.dataset.productTitle || '');
    contactUrl.searchParams.set('variant', variant.dataset.title || variant.textContent.trim());
    contactUrl.searchParams.set('product_url', productUrl.toString());
    link.href = contactUrl.toString();
  }

  function rememberedVariant(productId) {
    try {
      return sessionStorage.getItem('ohara:variant:' + productId);
    } catch {
      return null;
    }
  }

  function rememberVariant(select) {
    const root = select.closest('[data-diamond-product]');
    if (!root?.dataset.productId) return;
    try {
      sessionStorage.setItem('ohara:variant:' + root.dataset.productId, select.value);
    } catch {}
  }

  function updateOriginLinks(select) {
    const root = select.closest('[data-diamond-product]');
    const chosen = select.selectedOptions[0];
    if (!root || !chosen) return;
    let options;
    try {
      options = JSON.parse(chosen.dataset.options || '[]');
    } catch {
      options = [];
    }
    root.querySelectorAll('[data-origin-product]').forEach(link => {
      const bank = root.querySelector('[data-origin-variants="' + link.dataset.originProduct + '"]');
      if (!bank) return;
      let variants;
      try {
        variants = JSON.parse(bank.textContent);
      } catch {
        return;
      }
      const remembered = rememberedVariant(link.dataset.originProduct);
      const target = link.dataset.originProduct === root.dataset.productId
        ? variants.find(variant => String(variant.id) === select.value)
        : variants.find(variant => String(variant.id) === remembered)
          || variants.find(variant => options.length && JSON.stringify(variant.options) === JSON.stringify(options));
      const url = new URL(link.href, window.location.origin);
      if (target) url.searchParams.set('variant', target.id);
      else url.searchParams.delete('variant');
      link.href = url.toString();
    });
  }

  function restoreVariant(select) {
    const root = select.closest('[data-diamond-product]');
    const requested = new URL(window.location.href).searchParams.get('variant');
    const candidate = requested || rememberedVariant(root?.dataset.productId);
    if (candidate && Array.from(select.options).some(option => option.value === candidate)) {
      select.value = candidate;
    }
    if (requested) rememberVariant(select);
  }

  function updateDiamondProduct(select) {
    const root = select.closest('[data-diamond-product]');
    const variant = select.selectedOptions[0];
    if (!root || !variant) return;
    resetProductZoom(root);
    updateOriginLinks(select);
    updateProductContactLink(root, variant);
    root.querySelector('[data-product-price]').textContent = variant.dataset.price;
    const button = root.querySelector('[data-product-buy]');
    button.disabled = variant.dataset.available !== 'true';
    const buttonLabel = button.querySelector('[data-product-buy-label]') || button;
    buttonLabel.textContent = button.disabled ? button.dataset.unavailable : button.dataset.add;
    updateProductScale(root, select, variant.dataset.title || variant.textContent);
    updateVariantGallery(root, variant);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.value);
    history.replaceState({}, '', url);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gallery-thumb]');
    if (!button) return;
    showProductMedia(button.closest('[data-diamond-product]'), button.dataset.mediaId);
  });

  document.querySelectorAll('[data-product-variant]').forEach(select => {
    updateVariantGallery(select.closest('[data-diamond-product]'), select.selectedOptions[0]);
  });

  document.querySelectorAll('.product-media-stage').forEach(stage => {
    enableInlineZoom(stage);
    let frame;
    stage.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => syncProductGallery(stage));
    }, { passive: true });
  });

  document.addEventListener('change', event => {
    if (event.target.matches('[data-product-variant]')) {
      rememberVariant(event.target);
      updateDiamondProduct(event.target);
    }
  });

  document.addEventListener('click', event => {
    const closeButton = event.target.closest('[data-cart-confirmation-close]');
    if (closeButton) closeButton.closest('[data-cart-confirmation]')?.close();
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-diamond-product] form[action*="/cart/add"]');
    const root = form?.closest('[data-diamond-product]');
    const button = root?.querySelector('[data-product-buy]');
    if (!form || !root || !button) return;
    if (event.submitter !== button) return;
    if (button.disabled) {
      event.preventDefault();
      return;
    }
    if (!form.checkValidity()) return;

    event.preventDefault();
    button.disabled = true;
    const buttonLabel = button.querySelector('[data-product-buy-label]') || button;
    const originalText = buttonLabel.textContent;

    try {
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Add to cart failed');

      const cartPath = new URL(form.action, window.location.origin).pathname.replace(/\/add$/, '');
      const cart = await fetch(cartPath + '.js', {
        headers: { Accept: 'application/json' }
      }).then(cartResponse => {
        if (!cartResponse.ok) throw new Error('Cart refresh failed');
        return cartResponse.json();
      });

      document.querySelectorAll('a').forEach(link => {
        if (new URL(link.href, window.location.origin).pathname !== cartPath) return;
        const count = link.querySelector('[data-header-cart-count]');
        if (count) {
          count.textContent = String(cart.item_count);
        } else {
          link.textContent = link.textContent.replace(/\(\d+\)\s*$/, `(${cart.item_count})`);
        }
      });

      const selected = form.querySelector('[data-product-variant]')?.selectedOptions[0];
      const confirmation = root.querySelector('[data-cart-confirmation]');
      if (confirmation && selected) {
        confirmation.querySelector('[data-cart-confirmation-variant]').textContent =
          selected.dataset.title || selected.textContent;
        confirmation.querySelector('[data-cart-confirmation-price]').textContent =
          selected.dataset.price || '';
        confirmation.showModal();
      }
    } catch (error) {
      form.submit();
    } finally {
      button.disabled = false;
      buttonLabel.textContent = originalText;
    }
  });

  document.querySelectorAll('[data-product-variant]').forEach(select => {
    restoreVariant(select);
    updateDiamondProduct(select);
  });

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-origin-product]');
    const select = link?.closest('[data-diamond-product]')?.querySelector('[data-product-variant]');
    if (select) rememberVariant(select);
  });

  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-product-variant]').forEach(updateOriginLinks);
  });

  } catch(e) { console.error(e); }
})();
})();
